import React, { useState } from "react";
import "../styles/home.css";
import { useBackground } from "../context/BackgroundContext";
import emailjs from "@emailjs/browser";

function Footer() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const { theme } = useBackground();

  // Determine which social links to show based on current route
  // const getSocialLinks = () => {
  //   const pathname = location.pathname;

  //   if (pathname === "/home" || pathname === "/cart" || pathname === "/about") {
  //     return null;
  //   }

  //   if (
  //     pathname.includes("/resin-art") ||
  //     pathname.includes("/texture-paint") ||
  //     pathname.includes("/kidsShirt") ||
  //     pathname.includes("/texturePaint")
  //   ) {
  //     return {
  //       facebook: "https://www.facebook.com/resinartpage",
  //       instagram: "https://www.instagram.com/resinartpage",
  //       twitter: "https://twitter.com/resinartpage",
  //       youtube: "https://www.youtube.com/resinartpage",
  //     };
  //   }

  //   if (
  //     pathname.includes("/men-shirts") ||
  //     pathname.includes("/women-shirts") ||
  //     pathname.includes("/menShirts") ||
  //     pathname.includes("/womenShirts")
  //   ) {
  //     return {
  //       facebook: "https://www.facebook.com/fesishop",
  //       instagram: "https://www.instagram.com/fesishop",
  //       twitter: "https://twitter.com/fesishop",
  //       youtube: "https://www.youtube.com/fesishop",
  //     };
  //   }
  // };

  const socialLinks = {
    facebook: "https://www.facebook.com/Mfaisal424/",
    instagram: "https://www.instagram.com/fesishop.store",
    tiktok: "https://www.tiktok.com/@fesishop.store",
    youtube: "https://www.youtube.com/@FesiShopstore",
  };

  const handleSendEmail = (e) => {
    e.preventDefault();
    setAlert({
      show: true,
      type: "dark",
      message: "Message sent successfully!",
    });

    emailjs
      .send(
        "service_5jni33d",
        "template_dy8rw19",
        {
          from_name: name,
          from_email: email,
          to_name: "Faisal",
          phone_number: phoneNumber,
          message,
        },
        "s_s3Ri-GsCXMi8W4Q"
      )
      .then(
        () => {
          setName("");
          setEmail("");
          setPhoneNumber("");
          setMessage("");
          showAlert("dark", "Message sent successfully!");
        },
        (error) => {
          showAlert(
            "danger",
            "Failed to send message. Please try again later."
          );
          console.log("FAILED...", error.text);
        }
      );
  };

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
    setTimeout(() => {
      setAlert({ show: false, type: "", message: "" });
    }, 3000);
  };

  return (
    <footer className="footer-section text-light">
      {/* Contact Form */}
      <div className="contact-form-container px-5 my-5">
        <h2 className="text-center mb-4" style={{ color: theme.text }}>
          Contact Us
        </h2>
        <p className="text-center mb-4 fw-500" style={{ color: theme.text }}>
          We'd love to hear from you for orders, queries, or custom projects.
        </p>
        {alert.show && (
          <div className={`alert alert-${alert.type} fade show`} role="alert">
            {alert.message}
          </div>
        )}
        <form
          onSubmit={handleSendEmail}
          className="contact-form-fields"
          style={{ backgroundColor: theme.accent }}
        >
          <div className="row">
            <div className="col-md-12 mb-2">
              <input
                type="text"
                name="from_name"
                className="form-control"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{ backgroundColor: theme.primary, color: theme.text }}
              />
            </div>
            <div className="col-md-12 mb-2">
              <input
                type="email"
                name="from_email"
                className="form-control"
                placeholder="Email *"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ backgroundColor: theme.primary, color: theme.text }}
              />
            </div>
          </div>
          <div className="mb-3">
            <input
              type="tel"
              name="phoneNumber"
              className="form-control"
              placeholder="Phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              style={{ backgroundColor: theme.primary, color: theme.text }}
            />
          </div>
          <div className="mb-3">
            <textarea
              className="form-control"
              name="message"
              placeholder="Comment"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              style={{ backgroundColor: theme.primary, color: theme.text }}
            />
          </div>
          <button
            type="submit"
            className="btn-light mt-4 contact-btn"
            style={{ backgroundColor: theme.primary, color: theme.text }}
            disabled={
              name === "" ||
              email === "" ||
              phoneNumber === "" ||
              message === ""
            }
          >
            Send Message
          </button>
        </form>
      </div>

      {/* Footer Columns */}
      <div className="footer-content p-5">
        <div className="row">
          <div className="col-md-3 footer-column">
            <h4>About T-Shirts (Apparel)</h4>
            <p>
              We craft high-quality apparel focusing on modern comfort and
              style. Our tees are made with premium cotton for lasting wear.
              Look sharp, feel great.
            </p>
            <a href="/men-shirts" className="footer-link">
              Explore T-Shirts
            </a>
          </div>

          <div className="col-md-3 footer-column">
            <h4>About Resin Art (Handicrafts)</h4>
            <p>
              Discover unique, handcrafted resin masterpieces. Each piece is
              meticulously poured and designed for elegance and lasting beauty
              in home decor and jewelry.
            </p>
            <a href="/resin-art" className="footer-link">
              Explore Resin Art
            </a>
          </div>

          <div className="col-md-3 footer-column">
            <h4>Customer Service</h4>
            <a href="/about" className="footer-link d-block">
              Contact Us
            </a>
            <a href="/about" className="footer-link d-block">
              FAQ
            </a>
            <a href="/about" className="footer-link d-block">
              Privacy Policy
            </a>
          </div>

          <div className="col-md-3 footer-column">
            <h4>Contact Info</h4>
            {socialLinks && (
              <div className="social-media-section">
                <div className="social-icons">
                  <a
                    href={socialLinks.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link me-3"
                  >
                    <i className="bi bi-facebook fs-3 text-primary"></i>
                  </a>
                  <a
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link me-3"
                  >
                    <i className="bi bi-instagram fs-3 text-danger"></i>
                  </a>
                  <a
                    href={socialLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link me-3"
                  >
                    <i className="bi bi-tiktok fs-3 text-danger"></i>
                  </a>
                  <a
                    href={socialLinks.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link"
                  >
                    <i className="bi bi-youtube fs-3 text-danger"></i>
                  </a>
                </div>
              </div>
            )}
            <a
              href="https://mail.google.com/mail/u/0/?fs=1&to=mfaisal9c@gmail.com&su=From%20FesiRH110&body=Hi,%20I%20wanted%20to%20ask..&bcc=&tf=cm"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Email: mfaisal9c@gmail.com
            </a>
            <a
              href="tel:+9203154725501"
              target="_blank"
              className="d-block mt-2"
              rel="noopener noreferrer"
            >
              {" "}
              Phone: +92 0315 4725501
            </a>
          </div>
        </div>
      </div>

      <div className="copyright text-center py-3">
        <p>&copy; 2024 LibasStore. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
